import React, { Fragment } from 'react';
import Header from '../NewProfile/Header';
import './Terms.css';

import { Link, useHistory, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import NYCFooter from '../Layout/NYCFooter';
import SFFooter from '../Layout/SFFooter';
import TorontoFooter from '../Layout/TorontoFooter';
import NewTermsContent from './NewTermsContent';
import OttawaFooter from '../Layout/OttawaFooter';
import NewTermsContentSF from './NewTermsContentSF';

const NewTerms = () => {
  const history = useHistory();
  const pathname = history.location.pathname;

  const privacyUrl = pathname.includes('tor')
    ? 'https://autzu.com/tor/privacy'
    : pathname.includes('nyc')
    ? 'https://autzu.com/nyc/privacy'
    : 'https://autzu.com/sf/privacy';

  const isSF = pathname.includes('sf');

  return (
    <Fragment>
      <div className="new-terms">
        <div className="terms__title">
          <h1>Terms & Conditions</h1>
        </div>
        <div className="container">
          <Helmet>
            <title>Terms & Conditions | Autzu</title>
            <meta name="description" />
          </Helmet>
          {window.innerWidth >= 768 && (
            <Header persistentTitle title="Terms" />
          )}
          {isSF ? (
            <NewTermsContentSF
              pathname={pathname}
              privacyUrl={privacyUrl}
            />
          ) : (
            <NewTermsContent pathname={pathname} privacyUrl={privacyUrl} />
          )}
        </div>
        {window.innerWidth >= 768 && pathname.includes('tor') ? (
          <TorontoFooter />
        ) : pathname.includes('sf') ? (
          <SFFooter />
        ) : pathname.includes('ott') ? (
          <OttawaFooter />
        ) : (
          <NYCFooter />
        )}
      </div>
    </Fragment>
  );
};

export default withRouter(NewTerms);



// WEBPACK FOOTER //
// ./src/components/Static/NewTerms.js